export interface TResource {
  id: string
  name: string
  surname: string
  [key: string]: unknown // todo declare resource fields
}

export const create = (data?: any): TResource => ({
  ...data,
})
